import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin"
gsap.registerPlugin(ScrollToPlugin);
// import YouTubePlayer from 'youtube-player';

export const getDisplayMode = () =>{
  var layoutMode = null;
  var LAYOUTMODE__DESKTOP = 1;
  var LAYOUTMODE__MODILE = 2;
  var BREAK_POINT = "(min-width: 769px)";

  function matchMedia() {
    if (window.matchMedia(BREAK_POINT).matches) {
      if (layoutMode == LAYOUTMODE__DESKTOP) return;
      layoutMode = LAYOUTMODE__DESKTOP;

    } else {
      if (layoutMode == LAYOUTMODE__MODILE) return;
      layoutMode = LAYOUTMODE__MODILE;
    }

    return layoutMode;
  }

  function resize() {
    return matchMedia();
  }

  window.addEventListener('resize', function() {
    return resize()
  });

  return resize();

};

export const spanWrapText = (targets) => {
  targets.forEach( function (target) {
    let nodes = [...target.childNodes];
    let textBox = '';
    nodes.forEach( function (node) {
      if (node.nodeType == 3) { //テキストの場合
        let text = node.textContent.replace(/\r?\n/g, ''); //テキストから改行コード削除
        text.split('').forEach(function (t) {
          if (t !== " ") {
          textBox += '<span class="char">' + t + '</span>';
        } else {
          textBox += t;
        }
      });
    } else if (node.contains(node) == true) { // テキストではなく、子ノード(=span要素)を持つ
      let childNodes = [...node.childNodes];
      let childTextBox = '';
      childNodes.forEach( function (childeNode) {
        if (childeNode.nodeType == 3) { //テキストの場合
          let childeText = childeNode.textContent.replace(/\r?\n/g, ''); //テキストから改行コード削除
          childeText.split('').forEach(function (ct) {
            if (ct !== " ") {
              childTextBox += '<span class="char">' + ct + '</span>';
            } else {
              childTextBox += ct;
            }
          });
        } else if (childeNode.contains(node) == true) {
            // そのまま連結
            childTextBox = childTextBox + childeNode.outerHTML;
        } else {
            childTextBox = childTextBox + childeNode.outerHTML;
        }
      })

      node.innerHTML = childTextBox
      textBox = textBox + node.outerHTML;

    } else { // テキストではなく、br要素などspan要素以外の要素を持つ
        textBox = textBox + node.outerHTML;
      }
    })
    target.innerHTML = textBox
  })

  return targets;
};

export const smoothScroll = () => {
  console.log('test')
  const headerHeight = document.querySelector('#site-header').clientHeight;

  function setSmoothScroll() {
    const smoothScrollTrigger = document.querySelectorAll('.anc-nav');

    for (let i = 0; i < smoothScrollTrigger.length; i++){
      smoothScrollTrigger[i].addEventListener('click', (e) => {
        e.preventDefault();
        let href = smoothScrollTrigger[i].getAttribute('href');
        gsap.to(window, {
          ease: "power2.Out",
          duration: .5,
          scrollTo: {
            y: href,
            // offsetY: headerHeight
          }
        });
      });
    }
  }

  setSmoothScroll();
};

export const setModal = () => {
  // IFrame Player API の読み込みタグを挿入
  const tag = document.createElement('script') // scriptタグを生成
  tag.src = "https://www.youtube.com/iframe_api"  // APIのURLを付与
  const firstScriptTag = document.getElementsByTagName('script')[0] // 生成したタグをセット
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag) // HTML上に挿入

  const body = document.querySelector('body');
  let modalList = [];

  function openModal(obj) {
    obj.target.classList.add('is-open');
    body.classList.add('no-scroll');

    if(obj.player) {
      obj.player.seekTo(0)
      obj.player.playVideo();
    }
  }

  function closeModal(obj) {
    if(obj.player) {
      obj.player.pauseVideo();
    }
    obj.target.classList.remove('is-open');
    body.classList.remove('no-scroll');
  }

  const triggers = document.querySelectorAll('.js-modal-trigger');

  triggers.forEach((trigger) => {
    const obj = {};
    obj.contentsId = trigger.dataset.modalcontentid;
    obj.target = document.getElementById(obj.contentsId);
    obj.closeBtn = obj.target?.querySelector('.modal-close');
    obj.modalBg = obj.target?.querySelector('.modal-bg');
    obj.videoContainerId= trigger.dataset.videocontainerid;
    obj.videoId = trigger.dataset.videoid;

    if(obj.videoContainerId && obj.videoId) {
      window.onYouTubeIframeAPIReady = function() {
        obj.player = new YT.Player(obj.videoContainerId, { // YT.Playerオブジェクトを作成（'player'は動画の挿入先のid名）
          videoId: obj.videoId,
          playerVars: {
            'rel': 0  // これで関連動画をYouTube全体から表示
          },
        })
      };
    }

    modalList.push(obj)

    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      openModal(obj);
    });

    obj.closeBtn?.addEventListener('click', function() {
      closeModal(obj);
    });

    obj.modalBg?.addEventListener('click', function() {
      closeModal(obj);
    });
  })
}



export const globalNav = () => {
  const nav = document.getElementById("js-globalnav");
  const btn = document.getElementById("js-gn-menu");
  // const menu = nav.getElementsByClassName("gnav-item");

  const open = () => {
    document.querySelector('body').style.overflow = "hidden";
    nav.classList.add("is-open");
  };

  const close = () => {
    document.querySelector('body').style.overflow = "auto";
    nav.classList.remove("is-open");
  };

  btn.addEventListener("click", () => {
    btn.querySelector('.hamburger').classList.toggle("is-active");
    btn.querySelector('.hamburger').classList.contains("is-active") ? open() : close();
  });

  nav.classList.remove('preload');
};